export enum Access {
	SUPER = 'super',
	ALL_ACCESS = 'all_access',
	MANAGEMENT = 'management',
	STAFF = 'staff',
}
